export const mediaLarge = "(min-width: 992px)";
